// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// // 引用API文件
// import api from './api/index.js'
// // 将API方法绑定到全局
// Vue.prototype.$api = api

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './assets/iconfont.css'
// 引入初始化样式
import './styles/index.css'

// 引入Mint
import Mint from 'mint-ui' 
import 'mint-ui/lib/style.css'

// 引入axios
import axios from 'axios'
import VueAxios from 'vue-axios'

const httpService = axios.create({
  //baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASEURL : '',
  baseURL: '',
  timeout: 3600000, //请求超时时间
});

//拦截请求
httpService.interceptors.request.use((config) => {
  //const timeStamp = new Date().valueOf()
  console.log(`output->`,config)
    config.headers["Sign"] = '';
  return config;
});

// title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)


// 引入video.js

 
import Videojs from 'video.js'
 
import 'video.js/dist/video-js.css'
 
Vue.prototype.$video = Videojs
 

Vue.use(Mint);
Vue.use(ElementUI)
Vue.use(VueAxios, axios) 
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js